import {
  AuthenticationDetails, CognitoUser, CognitoUserAttribute, CognitoUserPool
} from 'amazon-cognito-identity-js';
import * as AWS from 'aws-sdk/global';
import {Credentials} from "aws-sdk";
import {GET_ORG_USER} from '../../queries';
import {getCognitoTokensFromLocalStorage} from '../../utils';
import { history } from '../../history';

export const ROLE_MEMBER = 10;
export const ROLE_ADMIN = 100;
export const ROLE_SUPER_ADMIN = 200;

export default class Auth {
  userPool:any;
  poolData:any;

  constructor() {
    this.getUserOrgs = this.getUserOrgs.bind(this);
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.refreshToken = this.refreshToken.bind(this);
    this.refreshChatbotAuth = this.refreshChatbotAuth.bind(this);

    this.poolData = {
      UserPoolId : process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
      ClientId : process.env.REACT_APP_COGNITO_APP_CLIENT_ID || ''
    };

    this.userPool = new CognitoUserPool(this.poolData);
  }

  async getUserOrgs(client: any) {
    const userId = localStorage.getItem('syncarto_user_id');
    if (!userId) {
      throw new Error("Could not find user id in local storage");
    }
    if (!this.isLoggedIn) {
      throw new Error("Current user is not logged in");
    }
    const userName = localStorage.getItem('syncarto_username');
    return client.query({
      query: GET_ORG_USER,
      variables: {user_id: userId},
      optimisticResponse: null
    }).then((result:any) => {
      console.log('GET_ORG_USER', result);
      return result.data.syncarto_app_org_user.map((org_user: any) => {
        let roleId = org_user.role_id;
        if (roleId !== ROLE_ADMIN && roleId !== ROLE_SUPER_ADMIN) {
          roleId = ROLE_MEMBER;
        }
        const orgId = org_user.org_id;
        const orgName = org_user.org.name;
        const orgLogo = org_user.org.org_logo_64;
        const orgLogoBground = org_user.org.org_logo_bground;
        return {roleId, userId, orgId, userName, orgName, orgLogo, orgLogoBground };
      });
    });
  }

  async handleAuthentication() {

  }

  isAuthenticated() {
    if (localStorage.getItem('syncarto_user_id')) {
      return true;
    }
    return false;
  }

  isLoggedIn() {
    const cognitoUser = this.userPool.getCurrentUser();
    if (cognitoUser != null) {
      return true;
    }
    return false;
  }

  /* id token expires every hour (which is not configurable);
   * need to use refresh token to get a new one w/o requiring user to re-login
   */
  refreshToken(orgId?: string) {
    return new Promise((resolve, reject) => {
      try{
        // https://www.npmjs.com/package/amazon-cognito-identity-js use case 32
        let cognitoUser = this.userPool.getCurrentUser();
        //cognitoUser = null;
        if (cognitoUser === null) {
          history.push('/login');
          resolve(true);
          return;
        }
        cognitoUser.getSession((err?: Error, session?: any) => {
          if (err) {
            console.log('Auth.refreshToken cognitoUser.getSession error', err);
            reject(err);
          } else if (session) {

            const refreshToken = session.getRefreshToken(); // receive session from calling cognitoUser.getSession()

            // Can do:
            // if ((AWS.config.credentials as Credentials).needsRefresh()) {
            // but the point is to refresh the id token *before* it ever actually expires!

            cognitoUser.refreshSession(refreshToken, async (err: any, session: any) => {
              if (err) {
                console.log('Auth.refreshToken cognitoUser.refreshSession error', err);
                console.warn('refresh token timed out; you must login again');
                // presumably means refresh token has expired (defaults to 30 days but IS configurable)
                // so we need to logout and redirect to login
                await this.logout();
                history.push('/login');
                resolve(true);
              } else {
                console.log('Auth.refreshToken cognitoUser.refreshSession success');

                // TODO this logic is duplicated in Auth.login
                AWS.config.region = process.env.REACT_APP_COGNITO_REGION || '';
                const loginKey = 'cognito-idp.' + AWS.config.region + '.amazonaws.com/' + this.poolData.UserPoolId;
                const Logins: any = {};
                Logins[loginKey] = session.getIdToken().getJwtToken();

                AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                  IdentityPoolId : process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || '',
                  Logins : Logins
                });

                (AWS.config.credentials as Credentials).refresh(async (err: any) => {
                  if (err) {
                    console.log('Auth.refreshToken AWS credentials refresh error', err);
                    reject(err);
                  } else {
                    console.log('Auth.refreshToken AWS credentials refresh TOKEN SUCCESSFULLY UPDATED');

                    // refresh chatbot jwt and session cookie with latest id token
                    try {
                      await this.refreshChatbotAuth(orgId);
                      resolve(true);
                    } catch (error) {
                      console.warn('failed to fetch hasura jwt or log in to chatbot. ', error);
                      reject(error);
                    }
                  }
                });
              }
            });
          }
        });
      } catch (error) {
          console.error("Error refreshing token:",error);
          history.push('/login');
          resolve(true);
          return;
      }
    });
  }

  async refreshChatbotAuth(requestedOrgId?: string) {

    // get token for hasura jwt auth using latest cognito idToken
    const tokens = getCognitoTokensFromLocalStorage();

    if (tokens) {
      const { idToken, accessToken } = tokens;
      // console.log('found local idToken: ', idToken);

      // set jwt token (used to authorize
      // graphql and tileserver requests)
      // TODO jwtToken endpoint could just set the session cookie
      // to avoid the dashboardLogin request, hmm..
      await fetch(`${process.env.REACT_APP_CHATBOT_URL}/jwtToken`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({idToken, requestedOrgId}),
      })
        .then(function(response) {
          if (response.ok) {
            return response.text();
          }
          throw new Error(''+response.status);
        })
        .then(function(data) {
          localStorage.setItem('syncarto_jwt', data);
          console.log('success getting chatbot jwt');

        })

      await fetch(`${process.env.REACT_APP_CHATBOT_URL}/dashboardLogin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({idToken, accessToken, requestedOrgId}),
        credentials: 'include', // necessary for cookie to get set
      })
        .then(function(response) {
          if (response.ok) {
            console.log('success getting chatbot cookie', response.text());
            return;
          }
          throw new Error(''+response.status);
        })

    } else {
      throw new Error('idToken and/or accessToken not present in local storage');
    }
  }

  async refreshPublicChatbotAuth() {
    console.log('start create public token');

    await fetch(`${process.env.REACT_APP_CHATBOT_URL}/anonymousJwtToken`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    })
      .then(function(response) {
        if (response.ok) {
          return response.text();
        }
        throw new Error(''+response.status);
      })
      .then(function(data) {
        localStorage.setItem('syncarto_jwt', data);        
        console.log('success getting chatbot public jwt');
      })
      .catch(error => {
        console.log(error);
      });

      console.log('complete create public token');
  }

  login(params: any) {
    try {
      // Clear all auth-related localStorage
      const storageKeys = Object.keys(localStorage).filter(key => (key.startsWith('syncarto_') || key.includes('CognitoIdentityServiceProvider')));
      storageKeys.forEach(key => localStorage.removeItem(key));
      
      // Clear AWS credentials
      if (AWS.config.credentials) {
        //(AWS.config.credentials as any).clearCachedId();
        (AWS.config.credentials as any).clearCachedId();
      }

      // Clear chatbot session cookies
      // Throws error -- theres a /dashboardLogin endpoint but no clear /dashboardLogout
      //fetch(`${process.env.REACT_APP_CHATBOT_URL}/dashboardLogout`, {
      //  method: 'POST',
      //  credentials: 'include'
      //});
      
      // Clear Cognito identity cache
      const setting = `aws.cognito.identity-id.${process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID}`;
      localStorage.removeItem(setting);

      // Additional cleanup for Cognito session
      //if (window.location.hostname === 'localhost') {
        // Clear development cookies explicitly
      document.cookie.split(';').forEach(c => {
        document.cookie = c.trim().split('=')[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
      });
      //}
    }catch{
      console.warn("Could not clear session caches upon login().")
    }
      
    const { username, password } = params;
    const authenticationData = {
      Username: username,
      Password: password
    };

    const authenticationDetails = new AuthenticationDetails(authenticationData);
    const userData = {
      Username : username,
      Pool : this.userPool
    };

    const poolData = this.poolData;

    var setting = `aws.cognito.identity-id.${process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID}`;
    window.localStorage.removeItem(setting);

    const cognitoUser = new CognitoUser(userData);

    return new Promise((resolve, reject) => {
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result: any) => {
          AWS.config.region = process.env.REACT_APP_COGNITO_REGION || '';

          const loginKey = 'cognito-idp.' + AWS.config.region + '.amazonaws.com/' + poolData.UserPoolId;
          const Logins: any = {};
          Logins[loginKey] = result.getIdToken().getJwtToken();

          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId : process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || '',
            Logins : Logins
          });

          //refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
          // mjh i think this is only needed if you need access to aws resources e.g. you want to do:
          // var s3 = new AWS.S3();
          (AWS.config.credentials as Credentials).refresh(async (error) => {
            if (error) {
              console.error(error);
              reject(error);
            } else {
              // Instantiate aws sdk service objects now that the credentials have been updated.
              // example: var s3 = new AWS.S3();

              // put user id into local storage
              cognitoUser.getSession(function(err?: Error, session?: any) {
                if (err) {
                  console.error(err.message || JSON.stringify(err));
                  return;
                }
                if (session) {
                  cognitoUser.getUserAttributes(function(err?: Error, attributes?: CognitoUserAttribute[]) {
                    if (err) {
                      console.error(err.message || JSON.stringify(err));
                      return;
                    }
                    if (attributes) {
                      attributes.forEach(function(attribute) {
                        if(attribute.getName() === 'sub') {
                          console.log("Assigning user ids and usernames");
                          localStorage.setItem('syncarto_user_id', attribute.getValue());
                          localStorage.setItem('syncarto_username', username.split('@')[0]);
                        }
                      });
                    }
                  });
                }
              });

              try {
                await this.refreshChatbotAuth();
                resolve(true);
              } catch (error) {
                console.warn('failed to fetch hasura jwt or log in to chatbot. ', error);
                reject(error);
              }
            }
          });

        },

        onFailure: function(err) {
          console.error(err);
          reject(err);
        }
      });
    });
  }

  getPermissions() {

  }

  authCheck() {
    const cognitoUser = this.userPool.getCurrentUser();
    if (cognitoUser != null) {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  }

  logout() {
    const userPool = this.userPool;
    return new Promise(function (resolve, reject) {
      // Clear all auth-related localStorage
      try {
        const storageKeys = Object.keys(localStorage).filter(key => (key.startsWith('syncarto_') || key.includes('CognitoIdentityServiceProvider')));
        storageKeys.forEach(key => localStorage.removeItem(key));
        
        // Clear AWS credentials
        if (AWS.config.credentials) {
          (AWS.config.credentials as any).clearCachedId();
          //(AWS.config.credentials as Credentials).clearCachedId();
        }

        // Clear chatbot session cookies
        // Throws error -- theres a /dashboardLogin endpoint but no clear /dashboardLogout
        //fetch(`${process.env.REACT_APP_CHATBOT_URL}/dashboardLogout`, {
        //  method: 'POST',
        //  credentials: 'include'
        //});

        const cognitoUser = userPool.getCurrentUser();
        if (cognitoUser != null) {
          cognitoUser.signOut();
        }
        
        // Clear Cognito identity cache
        const setting = `aws.cognito.identity-id.${process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID}`;
        localStorage.removeItem(setting);
      }catch{
        console.warn("Could not clear session caches upon logout().")
      }
      // Additional cleanup for Cognito session
      //if (window.location.hostname === 'localhost') {
        // Clear development cookies explicitly
      document.cookie.split(';').forEach(c => {
        document.cookie = c.trim().split('=')[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
      });
      //}

      resolve(true);
    });
  }

  getUnauthenticatedIdentity(callback: (id: string) => void) {
    AWS.config.region = process.env.REACT_APP_COGNITO_REGION || '';
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId : process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || ''
    });

    const credentials = AWS.config.credentials as AWS.CognitoIdentityCredentials;

    // Make the call to obtain credentials
    credentials.get(function(){
      // Credentials will be available when this function is called.
      var accessKeyId = credentials.accessKeyId;
      var secretAccessKey = credentials.secretAccessKey;
      var sessionToken = credentials.sessionToken;
      var token = credentials.identityId;

      console.log('get', { accessKeyId, secretAccessKey, sessionToken, token}); 

      callback(sessionToken);
    });
  }

  async registerUser(name: string, email: string, password: string, organization: string, terms: string) {
    const response = await fetch(`${process.env.REACT_APP_CHATBOT_URL}/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({name, email, password, organization, terms}),
    });

    if (!response.ok) {
      console.log(response.statusText);
      throw new Error(`${response.status}`);
    }
     
    return await response.json();
  }
}
